import axiosInterceptor from "../utils/axiosInterceptors";
import {
  customerAgentDetailsEndpoint,
  customerStatusTableEndpoint,
  viewCCDetailaAPI,
  orderServiceEndpoint,
  statusEndpoint,
  resendEmailAPI,
  orderLogEndpoint,
  downloadCsvEndpoint,
  plansEndpoint,
  planDetailsEndpoint,
  devicesEndpoint,
  deviceDetailsEndpoint,
  addDeviceEndpoint,
  addonsEndpoint,
  statesEndpoint,
  addAddonsEndpoint,
  addonDetailsEndpoint,
  addPlanEndpoint,
  rejectStatusEndpoint,
  credentialsEndpoint,
  sendCredentialsEndpoint,
  healthCheckEndpoint,
} from "./apiEndPoints";

export async function fetchCustomerStatusTableData(params) {
  try {
    const response = await axiosInterceptor.post(customerStatusTableEndpoint, {
      status: params.status,
      created_by: params.createdBy,
      from_date: params.fromDate,
      to_date: params.toDate,
      page: params.page,
      limit: params.limit,
      sort_by: params.sort_by,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function fetchOrderDetails(orderId) {
  try {
    const response = await axiosInterceptor.get(
      customerAgentDetailsEndpoint(orderId)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function orderService(orderId, status, reject_reason) {
  try {
    const payload = { status };
    if (reject_reason) {
      payload.reject_reason = reject_reason;
    }

    const response = await axiosInterceptor.patch(
      orderServiceEndpoint(orderId),
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const fetchStatuses = async () => {
  try {
    const response = await axiosInterceptor.get(statusEndpoint);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch statuses."
    );
  }
};

export const fetchRejectStatuses = async (params) => {
  try {
    const response = await axiosInterceptor.get(rejectStatusEndpoint(params));
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch reject statuses."
    );
  }
};

export async function viewCCDetails(orderId) {
  try {
    const response = await axiosInterceptor.get(viewCCDetailaAPI(orderId));
    return response.data;
  } catch (error) {
    return error;
  }
}

export async function triggerResendEmail(orderId) {
  try {
    const response = await axiosInterceptor.post(resendEmailAPI(orderId));
    return response.data;
  } catch (error) {
    return error;
  }
}

export async function fetchOrderLog(orderId) {
  try {
    const response = await axiosInterceptor.get(orderLogEndpoint(orderId));
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function downloadOrderCsv(params) {
  try {
    const response = await axiosInterceptor.get(downloadCsvEndpoint(params), {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const fetchPlans = async (page, limit, searchtext) => {
  try {
    const response = await axiosInterceptor.get(
      plansEndpoint(page, limit, searchtext)
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch plans.");
  }
};

export const addPlans = async (planData) => {
  try {
    const response = await axiosInterceptor.post(addPlanEndpoint, planData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to add plans.");
  }
};

export const deletePlans = async (id) => {
  try {
    const response = await axiosInterceptor.delete(planDetailsEndpoint(id));
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete plans.");
  }
};

export const fetchPlanDetails = async (id) => {
  try {
    const response = await axiosInterceptor.get(planDetailsEndpoint(id));
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch plan details."
    );
  }
};

export const editPlanDetails = async (id, updatedData) => {
  try {
    const response = await axiosInterceptor.put(
      planDetailsEndpoint(id),
      updatedData
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update plan.");
  }
};

export const fetchDevices = async (page, limit, searchtext) => {
  try {
    const response = await axiosInterceptor.get(
      devicesEndpoint(page, limit, searchtext)
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch devices."
    );
  }
};

export const fetchDeviceDetails = async (id) => {
  try {
    const response = await axiosInterceptor.get(deviceDetailsEndpoint(id));
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch device details."
    );
  }
};

export const addDevice = async (deviceData) => {
  try {
    const response = await axiosInterceptor.post(
      addDeviceEndpoint(),
      deviceData
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to add device.");
  }
};

export const deleteDevices = async (id) => {
  try {
    const response = await axiosInterceptor.delete(deviceDetailsEndpoint(id));
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete devices."
    );
  }
};

export const editDevice = async (id, updatedData) => {
  try {
    const response = await axiosInterceptor.put(
      deviceDetailsEndpoint(id),
      updatedData
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update device."
    );
  }
};

export const fetchAddons = async (page, limit, searchtext) => {
  try {
    const response = await axiosInterceptor.get(
      addonsEndpoint(page, limit, searchtext)
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch addons.");
  }
};

export const addAddon = async (addonData) => {
  try {
    const response = await axiosInterceptor.post(addAddonsEndpoint, addonData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to add addons.");
  }
};

export const fetchAddonDetails = async (id) => {
  try {
    const response = await axiosInterceptor.get(addonDetailsEndpoint(id));
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch plan details."
    );
  }
};

export const deleteAddons = async (id) => {
  try {
    const response = await axiosInterceptor.delete(addonDetailsEndpoint(id));
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete plans.");
  }
};

export const editAddonDetails = async (id, updatedData) => {
  try {
    const response = await axiosInterceptor.put(
      addonDetailsEndpoint(id),
      updatedData
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update addon.");
  }
};

export const fetchStates = async () => {
  try {
    const response = await axiosInterceptor.get(statesEndpoint);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch states.");
  }
};

export async function fetchCredentials(orderId) {
  try {
    const response = await axiosInterceptor.get(credentialsEndpoint(orderId));
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch credentials."
    );
  }
}

export async function sendCredentials(orderId, credentials) {
  try {
    const response = await axiosInterceptor.post(
      sendCredentialsEndpoint(orderId),
      credentials
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to send credentials."
    );
  }
}

export const healthCheck = async () => {
  try {
    const response = await axiosInterceptor.get(healthCheckEndpoint);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Heath Check failed");
  }
};
